import Vue from 'vue';

const state = {
  tickets: {}
}

const getters = {

  ticket (state) {
    return id => {
      if (id in state.tickets) return state.tickets[id];
      else return false;
    }
  },

  tickets (state) {
    return state.tickets;
  }
}

const mutations = {

  storeTickets (state, tickets) {
    
    tickets.forEach(ticket => {
      var current = state.tickets[ticket._id] || {};
      
      
      // Remove assignees to prevent it from combining them
      if (ticket.assignees) {
        delete current.assignees;
      }
      
      Vue.set(state.tickets, ticket._id, {
        ...current,
        ...ticket
      });
    });
  },

  removeTicket (state, id) {
    if (id in state.tickets) Vue.delete(state.tickets, id);
  },

  clearTickets () {
    Vue.set(state, 'tickets', {});
  }

}

const actions = {
  
  storeTicketLiveUpdate ({commit}, ticket) {
    var result = storeData([ticket]);  
    commit('storeTickets',    result.tickets);
    commit('storeTicketTags', result.ticketTags);
    commit('storeUnits',      result.units);
    commit('storeUsers',      result.users);
  },

  loadTickets ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.company) {
      return Promise.reject('state.tickets - loading Tickets - Missing required param "company"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateUnit: true,
        populateProperty: true,
        populateCompany: true,
        populateReporters: true,
        populateAssignees: true,
        populateType: true,
        onlyAssigned: false
      }
    };

    return window.server.getReq('company/' + params.company + '/tickets', {
      params: queryParams
    })
    .then(data => {
      
      // Parse Data out into property Stores
      var result = storeData(data);

      // commit('storeProperties', result.properties); // Cant do this for now because it loses data we need
      commit('storeTickets',    result.tickets);
      commit('storeTicketTags', result.ticketTags);
      commit('storeUnits',      result.units);
      commit('storeUsers',      result.users);

      return Promise.resolve(result.tickets);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },

  loadTicket ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.ticket) {
      return Promise.reject('state.tickets - loading Tickets - Missing required param "ticket"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateUnit: true,
        populateProperty: true,
        populateCompany: true,
        populateReporters: true,
        populateAssignees: true,
        populateType: true,
        onlyAssigned: false
      }
    };

    return window.server.getReq('/ticket/' + params.ticket, {
      params: queryParams
    })
    .then(data => {
      
      // Parse Data out into property Stores
      var result = storeData([data]);

      // commit('storeProperties', result.properties); // Cant do this for now because it loses data we need
      commit('storeTickets',    result.tickets);
      commit('storeTicketTags', result.ticketTags);
      commit('storeUnits',      result.units);
      commit('storeUsers',      result.users);

      return Promise.resolve(result.tickets[0]);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },

  createTicket ({commit, dispatch}, params) {
    if (!params.ticket || !params.ticket.property) {
      return Promise.reject('state.tickets - create Ticket - Missing required param "ticket"');
    }

    return window.server.postReq('/property/' + params.ticket.property + '/ticket/', {
      ticket: params.ticket
    })
    .then(data => {
      return dispatch('loadTicket', {
        ticket: data._id
      });
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  addTicketImage ({commit, dispatch}, params) {
    if (!params.ticket) {
      return Promise.reject('state.tickets - add Ticket Image - Missing required param "ticket"');
    }
    if (!params.image) {
      return Promise.reject('state.tickets - add Ticket Image - Missing required param "image"');
    }

    return window.server.postReq('ticket/' + params.ticket + '/image', params.image)
    .then(data => {
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  updateTicket ({commit, dispatch}, params) {
   
    if (!params.ticket || !params.ticket._id) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "ticket"');
    }
    if (!params.property) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "property"');
    }

    return window.server.putReq('/property/' + params.property + '/ticket/' + params.ticket._id, {
      ticket: params.ticket
    })
    .then(data => {
      return dispatch('loadTicket', {
        ticket: params.ticket._id
      });
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  addTicketAssignee ({commit, dispatch}, params) {
   
    if (!params.ticket || !params.ticket._id) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "ticket"');
    }
    if (!params.property) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "property"');
    }
    
    return window.server.putReq('property/' + params.property + '/ticket/' + params.ticket._id + '/assignees/add', {
      ticket: params.ticket
    })
    .then(data => {
      return dispatch('loadTicket', {
        property: params.property,
        ticket: params.ticket._id
      });
    })
    .catch(e => {
      return Promise.reject(e);
    });
  
  },

  removeTicketAssignee ({commit, dispatch}, params) {
   
    if (!params.ticket || !params.ticket._id) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "ticket"');
    }
    if (!params.property) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "property"');
    }
    
    return window.server.putReq('property/' + params.property + '/ticket/' + params.ticket._id + '/assignees/remove', {
      ticket: params.ticket
    })
    .then(data => {
      return dispatch('loadTicket', {
        property: params.property,
        ticket: params.ticket._id
      });
    })
    .catch(e => {
      return Promise.reject(e);
    });

  },

  ticketUpdateTags ({commit, dispatch}, params) {
   
    if (!params.ticket) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "ticket"');
    }
    if (!params.property) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "property"');
    }
    if (!params.ticketTag) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "ticketTag"');
    }
    if (!params.action || !(params.action === 'add' || params.action === 'remove')) {
      return Promise.reject('state.tickets - updating Ticket - Missing required param "action" - Must be "add" or "remove"');
    }
    
    return window.server.putReq('/ticket/' + params.ticket + '/ticketType/' + params.ticketTag + '/' + params.action)
    .then(data => {
      return dispatch('loadTicket', {
        property: params.property,
        ticket: params.ticket
      });
    })
    .catch(e => {
      return Promise.reject(e);
    });
  
  },
  
};

function storeData (tickets) {

  // Break out and store what we can
  var units       = {};
  var properties  = {};
  var users       = {};
  var ticketTags  = {};
  
  tickets.forEach((ticket, i) => {

    if (ticket.unit && ticket.unit._id) {
      if (!(ticket.unit._id in units)) units[ticket.unit._id] = ticket.unit;
      tickets[i].unit = ticket.unit._id;
    }

    if (ticket.property && ticket.property._id) {
      if (!(ticket.property._id in properties)) properties[ticket.property._id] = ticket.property;
      tickets[i].property = ticket.property._id;
    }

    ticket.assignees.forEach((assignee, j) => {
      if (!(_.isString(assignee))) {
        if (!(assignee._id in users)) users[assignee._id] = assignee;
        tickets[i].assignees[j] = assignee._id;
      }
    });

    ticket.reporters.forEach((user, j) => {
      if (!(_.isString(user))) {
        if (!(user._id in users)) users[user._id] = user; 
        tickets[i].reporters[j] = user._id;
      }
    });
    

    if (!Array.isArray(ticket.type)) tickets[i].type = ticket.type = [ticket.type];
    
    ticket.type.forEach((ticketTag, j) => {
      if (ticketTag !== null) { // This can happen on live updates
        if (!(ticketTag._id in ticketTags)) ticketTags[ticketTag._id] = ticketTag;
        tickets[i].type[j] = ticketTag._id;
      }
    })
  
  }); 

  properties  = _.values(properties);
  ticketTags  = _.values(ticketTags);
  units       = _.values(units);
  users       = _.values(users);

  return {
    properties,
    tickets,
    ticketTags,
    units,
    users
  };
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/ticket.js